import { useQuery, useMutation } from "react-query";
import {
	get_all_reward_rules_api,
	get_reward_rule_by_id_api,
	add_reward_rule_api,
	update_reward_rule_api,
	toggle_reward_rule_status_api,
	delete_reward_rule_api,
} from "../services/rewardRules";

export const useGetAllRewardRules = (payload) =>
	useQuery(["getAllRewardRules", payload], () =>
		get_all_reward_rules_api(payload)
	);

export const useGetRewardRuleById = (id, makeCall) =>
	useQuery(
		["rewardRuleById", id],
		() => get_reward_rule_by_id_api(id),
		makeCall
	);

export const useAddRewardRule = () =>
	useMutation("addRewardRule", (body) => add_reward_rule_api(body));

export const useUpdateRewardRule = () =>
	useMutation("updateRewardRule", (body) => update_reward_rule_api(body));

export const useToggleRewardRuleStatus = () =>
	useMutation("toggleRewardRuleStatus", (id) =>
		toggle_reward_rule_status_api(id)
	);

export const useDeleteRewardRule = () =>
	useMutation("deleteRewardRule", (id) => delete_reward_rule_api(id));
